// src/directives/intersect.js
export default {
  bind(el, binding) {
    // 默认配置
    let defaultOptions = {
      root: null,
      threshold: 0.1,
      rootMargin: "0px",
    };

    let handler = null;
    let once = false;

    // --- 解析 binding ---
    if (typeof binding.value === "function") {
      handler = binding.value;
    } else if (typeof binding.value === "object" && binding.value !== null) {
      handler = binding.value.handler;
      once = !!binding.value.once;
      defaultOptions = Object.assign(defaultOptions, binding.value);
    }

    // --- 懒加载模式 ---
    const isLazy = binding.modifiers.lazy;
    if (isLazy && typeof binding.value === "string") {
      handler = () => {
        el.src = binding.value; // 懒加载图片
      };
      once = true;
    }

    // --- 创建 Observer ---
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (handler) handler(entry);

          if (once) {
            observer.unobserve(el);
            observer.disconnect();
          }
        }
      });
    }, defaultOptions);

    observer.observe(el);

    // 存到元素上，方便解绑
    el._observer = observer;
  },
  unbind(el) {
    if (el._observer) {
      el._observer.disconnect();
      delete el._observer;
    }
  },
};
